import ExtensionsGlobal from '../../components/extensionsGlobal/ExtensionsGlobal';

function Extensions({onSubmitForm}) {
    return (
        <ExtensionsGlobal onSubmitForm={onSubmitForm} image={'ballGame'} text="extensionsDesc" continueBtn='participantDetails' />
    );
}

export default Extensions;
